import { api } from 'config/default.json';

export const getBaseUrl = (): string => {
  const hostname = window.location.hostname

  // تشخیص خودکار بر اساس دامنه فرانت
  if (
    hostname === 'daroog.com' ||
    hostname.endsWith('.daroog.com') ||
    hostname === 'daroog.net' ||
    hostname.endsWith('.daroog.net')
  ) {
    return api.production;
  }
  if (hostname === 'text-mining.ir' || hostname.endsWith('.text-mining.ir')) {
    return api.test;
  }
  if (hostname === 'localhost') {
    return api.local;
  }
  
  // دامنه‌های ناشناخته نباید به سرور تست متصل شوند.
  return api.production;
}
